import { Component, Injector, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { GridOptions, GridReadyEvent } from 'ag-grid';
import { EdiFilesService } from './edi-files.service';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { BtnsForGridService } from 'app/utils/btns-for-grid/btns-for-grid.service';
import { ParentModule } from 'app/pages/A2-utils/ParentClass/parent-module';
import { Subscription } from 'rxjs';
import { ReservationService } from 'app/pages/trip-reservations/reservations.service';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { finalize } from 'rxjs/operators';
import { IMyDrpOptions } from 'mydaterangepicker';
import { IEdiFileAttestation } from '../../../core/interfaces/edi-file-attestation.interface';
import { _downloadFileGeneric } from 'app/utils/trip2-query-builder/utils/helpers';
import { T2CardComponent } from 'app/trip2-theme/components/t2-card/t2-card.component';
import { GridLayoutStore, moduleActionIdOf } from 'app/utils/grid-layout-menu/grid-layout-store';

@Component({
  selector: 'app-edi-files',
  templateUrl: './edi-files.component.html',
  styleUrls: ['./edi-files.component.scss'],
  providers: [GridLayoutStore],
})
export class EdiFilesComponent extends ParentModule implements OnInit, OnDestroy {
  grid: GridOptions;
  private gridData = [];
  subscriptions: Subscription[] = [];
  dataCurrentModule: any = {};
  fileTrackingNumber: number;
  search = null;
  myDateRange: any;
  searchBy = [
    {
      id: 0,
      description: 'File Tracking Number',
    },
    {
      id: 1,
      description: 'Delivery Date',
    },
  ];
  myDateRangePickerOptions: IMyDrpOptions = {
    dateFormat: 'yyyy-mm-dd',
  };
  selectedRow: IEdiFileAttestation = null;
  @ViewChild('TypeFileBeingGenerated') private typeFileBeingGenerated: T2CardComponent;
  typeOfFile = null;

  constructor(
    protected _ediFileService: EdiFilesService,
    protected _sweetAlertService: SweetAlertHelper,
    private btnsForGridService: BtnsForGridService,
    protected Inject: Injector,
    protected service: ReservationService,
    private _loadingService: T2LoadingService,
    private layoutStore: GridLayoutStore
  ) {
    super('app-edi-files', Inject);
    this.initResources();
  }

  get typeOfFileSelected() {
    return !this.typeOfFile;
  }

  ngOnInit() {
    this.initLayoutMenu();
  }

  initResources() {
    this.createGrid();
    this.observables();
  }

  observables() {
    this.subscriptions.push(
      this.btnsForGridService.clearFilterGrid$.subscribe({
        next: (filter) => {
          if (filter && this.grid.api) {
            const filterForGrid = {
              filter: () => this.grid.api.setFilterModel(null),
              sort: () => this.grid.api.setSortModel(null),
              saveLayoutGrid: () => this.saveLayout(),
            };
            return filterForGrid[filter]();
          }
        },
      }),
      this.actions.subscribe({
        next: (res) => {
          if (res) {
            this.dataCurrentModule = res;
            this.getLayout();
          }
        },
      }),
      this.actionsList$.subscribe({
        next: () => {
          this.disabledSaveLayout(
            this.isAllowedAction('EdiFileAttestLayoutGrid')
          );
        },
      })
    );
  }

  private createGrid() {
    this.grid = <GridOptions>{
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      columnDefs: [
        {
          headerName: '',
          width: 48,
          checkboxSelection: true,
        },
        {
          headerName: 'Delivery Date',
          field: 'deliverydateformat',
        },
        {
          headerName: 'FILE_TRACKING_NUMBER',
          field: 'filetrackingnumber',
        },
        {
          headerName: 'FILE_NAME',
          field: 'filename',
        },
        {
          headerName: 'CLAIM_PAYMENT_AMOUNT ',
          field: 'claimpaymentamount',
        },
        {
          headerName: 'NEW_CLAIM_COUNT',
          field: 'newclaimcount',
        },
        {
          headerName: 'FILE_TYPE',
          field: 'filetype',
        },
        {
          headerName: 'EARLIEST_DATE',
          field: 'earliestdateformat',
        },
        {
          headerName: 'LATEST_DATE',
          field: 'latestdateformat',
        },
        {
          headerName: 'EARLIEST_PAID DATE',
          field: 'earliestpaiddateformat',
        },
        {
          headerName: 'LATEST_PAID_DATE',
          field: 'latestpaiddateformat',
        },
        {
          headerName: 'TPID',
          field: 'tpid',
        },
        {
          headerName: 'REGION',
          field: 'letterregion',
        }
      ],
      onGridReady: (params: GridReadyEvent) => {
       params.api.sizeColumnsToFit();
        this.grid.api.setRowData([]);
      },
      onFilterChanged: (params) => {
        if (params && params.api) {
          this.btnsForGridService.btnDisabled({
            type: 'filter',
            disabled: params.api['filterManager'].advancedFilterPresent,
          });
          this.grid.api.deselectAll();
        }
      },
      onSortChanged: () => {
        const sort = this.grid.api.getSortModel();
        this.btnsForGridService.btnDisabled({
          type: 'sort',
          disabled: !!sort.length,
        });
      },
      onRowSelected: () => this.onGridSelectedRow()
    };
  }

  onGridSelectedRow(): void {
    const [selectedRow]: IEdiFileAttestation[] = this.grid.api.getSelectedRows();
    this.selectedRow = selectedRow;
  }

  askForTypeOfFile() {
    if (this.isAllowedAction('AskTypeOfFile')) {
      this.typeFileBeingGenerated.open();
    } else {
      this.typeOfFile = '0';
      this.downloadEdiFile();
    }
  }

  closeModalTypeOfFile() {
    this.typeFileBeingGenerated.close();
    this.typeOfFile = null;
  }

  downloadEdiFile() {
    const { filetrackingnumber: ediFileId } = this.selectedRow;

    this._loading.show();
    this.subscriptions.push(
      this._ediFileService
        .downloadEdiFile({
          ediFileId,
          isReplacement: this.typeOfFile,
        })
        .finally(() => {
          this._loading.hiden();
          this.closeModalTypeOfFile();
        })
        .subscribe({
          next: (response) =>
            _downloadFileGeneric(
              response.blob(),
              response.headers.get('X-Custom-Header-FileName')
            ),
          error: (error) => {
            if (error && error.headers) {
              this._sweetAlertService
                .createCustomAlert({
                  title: 'Error generating file',
                  text: error.headers.get('X-Custom-Header-FileName'),
                  type: 'error',
                  showCancelButton: true,
                  confirmButtonText: 'Close',
                  cancelButtonText: 'Force Download',
                })
                .then((result) => {
                  const { dismiss } = result;
                  if (dismiss) {
                    this.forceDownloadEdiFile(ediFileId);
                  }
                });
            }
          },
        })
    );
  }

  forceDownloadEdiFile (ediFileId: number) {
    this._loading.show();
    this.subscriptions.push(
      this._ediFileService.downloadEdiFile({ediFileId, force: true})
        .finally(() => this._loading.hiden())
        .subscribe({
          next: (response) => _downloadFileGeneric(response.blob(), response.headers.get('X-Custom-Header-FileName')),
          error: (error) => {
            if (error && error.headers) {
              this._sweetAlertService.createCustomAlert({
                title: 'Error generating file',
                text: error.headers.get('X-Custom-Header-FileName'),
                type: 'error'
              }).then();
            }
          }
        })
    );
  }

  disabledSaveLayout(disabledBtn: boolean): void {
    this.btnsForGridService.btnDisabled({
      type: 'layout',
      disabled: disabledBtn,
    });
  }

  getLayout(): void {
    const moduleId = this.dataCurrentModule.moduleid;
    this.subscriptions.push(
      this.service.getRoleActionByModule(moduleId).subscribe({
        next: (data) => {
          const actionsLayout = data.find(
            (val: any) =>
              val.action.description === 'EdiFileAttestLayoutGrid' && val.layout
          );
          if (actionsLayout && actionsLayout.layout) {
            this.grid.columnApi.setColumnState(
              JSON.parse(actionsLayout.layout.config)
            );
          }
        },
        error: (error) => {
          this._sweetAlertService.captureException(error);
        },
      })
    );
  }

  saveLayout(): void {
    if (this.grid.columnApi.getColumnState().length) {
      const MODULE_ACTION_ID =
        this.dataCurrentModule.actions.EdiFileAttestLayoutGrid.moduleactionid;
      const stringLayout = JSON.stringify(this.grid.columnApi.getColumnState());
      const data = { moduleactionid: MODULE_ACTION_ID, config: stringLayout };
      this.btnsForGridService.saveLayoutGrid(data);
    }
  }

  getFiles() {
    let beginDate: string;
    let endDate: string;
    if (this.myDateRange) {
      beginDate = this.getFormattedDate(this.myDateRange.beginDate);
      endDate = this.getFormattedDate(this.myDateRange.endDate);
    }

    if (this.fileTrackingNumber || (beginDate && endDate) ) {
      this._loadingService.show();
      this.subscriptions.push(
        this._ediFileService
          .getFiles(this.fileTrackingNumber, beginDate , endDate)
          .pipe(
            finalize(() => {
            this._loadingService.hiden();
          }))
          .subscribe({
            next: (files: any) => {
              this.gridData = files;
              if (this.grid && this.grid.api) {
                const filter = this.grid.api.getFilterModel();
                this.grid.api.setRowData(this.gridData);
                this.grid.api.sizeColumnsToFit();
                this.grid.api.setFilterModel(filter);
              }
            },
            error: (err) => {
              this._sweetAlertService.captureException(err);
            },
          })
      );
    }
  }

  exportToExcel() {
    this.grid.api.exportDataAsExcel();
    this._sweetAlertService.createCustomAlert({
      title: 'Warning',
      text: 'The export process has been initiated',
      type: 'warning',
      timer: 1500,
      showConfirmButton: false,
    });
  }

  OnChangeSearch () {
    this.fileTrackingNumber = null;
    this.myDateRange = null;
    this.grid.api.setRowData([]);
  }

  formatDateNgModel(date: { day: any, month: any, year: any }): string {
    const formatNumber = (num: number) => (num < 10) ? `0${num}` : num;
    return `${formatNumber(date.month)}/${formatNumber(date.day)}/${date.year}`;
  }

  private getFormattedDate(date: any): string {
    return this.formatDateNgModel(date).replace(/\//g, '-');
  }

  get isDisabledExcel(): boolean {
    return !this.gridData.length;
  }

  get isFiletrackingNumber (): boolean {
    return this.search === searchByEnum.fileTranckingNumber.toString();
  }

  get isDateOfRegistration (): boolean {
    return this.search === searchByEnum.dateOfRegistration.toString();
  }

  get isDisabledButton (): boolean {
    return !this.fileTrackingNumber && !this.myDateRange;
  }

  get isDisabledDownloadButton(): boolean {
    return !this.selectedRow;
  }

  private initLayoutMenu() {
    this.subscriptions.push(this.layoutStore.follow(this.actionsList$, () => ({
      grid: this.grid,
      moduleActionId: moduleActionIdOf(this.dataCurrentModule, 'EdiFileAttestLayoutGrid'),
      title: 'EDI Files'
    })));
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}

enum searchByEnum {
  fileTranckingNumber = 0,
  dateOfRegistration = 1
 };



// WEBPACK FOOTER //
// ./src/app/pages/billing-general/edi-files/edi-files.component.ts